export default __webpack_public_path__ + "static/media/pic4.3a1cf158.jpg";